var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPopupDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 113,
    viewBox: "0 0 113 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.64 23.4301L17.7446 80.4024C17.1504 81.4313 16.8375 82.5984 16.8374 83.7865C16.8373 84.9746 17.15 86.1418 17.744 87.1707C18.338 88.1997 19.1924 89.0541 20.2214 89.6482C21.2503 90.2422 22.4175 90.5549 23.6056 90.5548H89.391C90.5791 90.5549 91.7463 90.2422 92.7752 89.6482C93.8042 89.0541 94.6586 88.1997 95.2526 87.1707C95.8466 86.1418 96.1593 84.9746 96.1592 83.7865C96.1591 82.5984 95.8462 81.4313 95.252 80.4024L62.3602 23.4301C61.7663 22.4015 60.912 21.5473 59.8834 20.9534C58.8547 20.3595 57.6879 20.0469 56.5001 20.0469C55.3123 20.0469 54.1454 20.3595 53.1168 20.9534C52.0881 21.5473 51.2339 22.4015 50.64 23.4301Z",
    fill: "#F62634"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9289 41.002H56.0708C53.9582 41.002 52.2456 42.7146 52.2456 44.8272V63.1111C52.2456 65.2237 53.9582 66.9363 56.0708 66.9363H56.9289C59.0415 66.9363 60.7542 65.2237 60.7542 63.1111V44.8272C60.7542 42.7146 59.0415 41.002 56.9289 41.002Z",
    fill: "#FFF7ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4999 81.4382C58.8494 81.4382 60.7542 79.5335 60.7542 77.184C60.7542 74.8344 58.8494 72.9297 56.4999 72.9297C54.1503 72.9297 52.2456 74.8344 52.2456 77.184C52.2456 79.5335 54.1503 81.4382 56.4999 81.4382Z",
    fill: "#FFF7ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupDeleteIcon);
export default __webpack_public_path__ + "static/media/popupDeleteIcon.0588c37df9c2d194e051c914704929d1.svg";
export { ForwardRef as ReactComponent };